import React from 'react';
import ReactDOM from 'react-dom';
import VehicleSearch from './components/VehicleSearch';
import VehicleSelect from './components/VehicleSelect';

const renderSearch = (element, options) => {
    ReactDOM.render(
        <React.StrictMode>
            <VehicleSearch {...options} />
        </React.StrictMode>,
        element
    );
}


const renderSelect = (element, options) => {
    ReactDOM.render(
        <React.StrictMode>
            <VehicleSelect {...options} />
        </React.StrictMode>,
        element
    );
}

window.vehiclesearch = {
    renderSearch,
    renderSelect,
};
